import type { CableSystem } from "../fetchCables";

/** Circuit colours, cycled per circuit index. */
export const PALETTE: Array<[number, number, number]> = [
  [59, 130, 246], [16, 185, 129], [239, 68, 68], [168, 85, 247],
  [234, 179, 8], [236, 72, 153], [14, 165, 233], [132, 204, 22],
  [249, 115, 22], [99, 102, 241], [20, 184, 166], [217, 70, 239],
];

// Special (non-power) control panels that must NOT be tagged as a "UV<n>"
// board. Matched by token anywhere in the name (case-insensitive); the panel
// keeps its own short prefix (and, where known, its installation system).
export const SPECIAL_PANELS: Array<{
  re: RegExp;
  label: string;
  system?: CableSystem;
}> = [
  { re: /\bBMZ\b/i, label: "BMZ", system: "bma" }, // Brandmelderzentrale
  { re: /\b(PAS|HES)\b/i, label: "PA", system: "earthing" }, // Potentialausgleich / Haupterdungsschiene
  { re: /\bZLT\b/i, label: "ZLT" }, // Zentrale Leittechnik
  { re: /\bGLT\b/i, label: "GLT" }, // Gebäudeleittechnik
  { re: /\b(SAT|MMZ)\b/i, label: "SAT", system: "media" }, // media / multimedia
  { re: /\b(KNX|KLR)\b/i, label: "KNX", system: "knx" },
];
